<p>
{{ ('firebase.confirm_msg' | translate).replace('%CUSTOMERNAME%', customerName) }}
</p>
{{ "firebase.not_remind_me" | translate}}&nbsp;<br/>
<button mat-button (click)="confirm(true)" color="primary">{{ 'Dialog.Yes' | translate }}</button>
<button mat-button (click)="confirm(false)" color="">{{ 'Dialog.No' | translate }}</button>
